export default class Calendar {
  constructor(
    {
      year = new Date().getFullYear(),
      month = new Date().getMonth() + 1,
      day = new Date().getDate(),
      hour = new Date().getHours(),
      minutes = new Date().getMinutes(),
      seconds = new Date().getSeconds()
    }
  ) {
    this.year = year;
    this.month = month;
    this.day = day;
    this.hour = hour;
    this.minutes = minutes;
    this.seconds = seconds;
    this.weekName = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
  }
  format(val) {
    if (val < 10) {
      return `0${val}`;
    }
    return val;
  }
  // 年表格
  yearTable() {
    let startYear = Math.floor(this.year / 10) * 10;
    return Array.from({
      length: 10
    }, () => ({
      year: startYear++
    }));
  }
  // 月表格
  monthTable() {
    let num = 1;
    return Array.from({
      length: 12
    }, () => ({
      month: num++,
      year: this.year
    }));
  }
  // 天表格
  dayTable() {
    let table = [];
    let sunDays = this.sumDaysMonth(this.month);
    let prevSunDays = this.sumDaysMonth(this.month - 1);
    // 某年某月第一天星期几  month比正常月份值少1
    let week = new Date(this.year, this.month - 1, 1).getDay();
    for (let i of Array.from({
      length: 6
    }).keys()) {
      for (let j of Array.from({
        length: 7
      }).keys()) {
        let day = 7 * i + j - week + 1;
        let month = this.month;
        let year = this.year;
        if (day < 1) {
          day = prevSunDays + day;
          month = month - 1;
        } else if (day > sunDays) {
          day = day - sunDays;
          month = month + 1;
        }
        table.push({
          day,
          month,
          year,
          week
        });
      }
    }
    return table;
  }
  // 闰年 or 平年
  isLeapYear() {
    return (this.year % 100 == 0 && this.year % 400 == 0) || (this.year % 100 != 0 && this.year % 4 == 0) ? 1 : 0
  }
  // 某月总天数
  sumDaysMonth(month) {
    return [31, 28 + this.isLeapYear(this.year), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month - 1 < 0 ? 11 : month - 1];
  }
  // 递增月
  nextMonth() {
    this.month++;
    if (this.month > 12) {
      this.year++;
      this.month = 1;
    }
  }
  // 递减月
  prevMonth() {
    this.month--;
    if (this.month < 1) {
      this.year--;
      this.month = 12;
    }
  }
};